import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InspectionItemType } from '../../modules/clientModule/types';

export type ActiveTabType = 'I' | 'R' | 'None';
export interface BulkState {
  bulkActiveTab: ActiveTabType;
  showBulkUpdatePopup: boolean;
  bulkDate: string;
  bulkInspections: InspectionItemType[];
  scheduledCount: number;
  additionlScheduledCount: number;
  inspectorId: number;
}

const initialState: BulkState = {
  bulkActiveTab: 'I',
  showBulkUpdatePopup: false,
  bulkDate: '',
  bulkInspections: [],
  scheduledCount: -1,
  inspectorId: -1,
  additionlScheduledCount: 0,
};

export const bulkSlice = createSlice({
  name: 'bulkSlice',
  initialState,
  reducers: {
    setBulkActiveTab: (state, action: PayloadAction<ActiveTabType>) => {
      state.bulkActiveTab = action.payload;
    },
    setShowBulkUpdatePopup: (state, action: PayloadAction<boolean>) => {
      state.showBulkUpdatePopup = action.payload;
    },
    setBulkDate: (state, action: PayloadAction<string>) => {
      state.bulkDate = action.payload;
    },
    setBulkInspections: (state, action: PayloadAction<InspectionItemType[]>) => {
      state.bulkInspections = action.payload;
    },
    setScheduledCount: (state, action: PayloadAction<number>) => {
      state.scheduledCount = action.payload;
    },
    setInspectorId: (state, action: PayloadAction<number>) => {
      state.inspectorId = action.payload;
    },
    setAdditionlScheduledCount: (state, action: PayloadAction<number>) => {
      state.additionlScheduledCount = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setScheduledCount,
  setBulkActiveTab,
  setShowBulkUpdatePopup,
  setBulkDate,
  setBulkInspections,
  setInspectorId,
  setAdditionlScheduledCount,
} = bulkSlice.actions;

export default bulkSlice.reducer;
